import { useMediaQuery } from 'react-responsive';
import { useState, useEffect } from 'react';
import useGlobalStore from '../../store/useGlobalStore';
import { useHover } from "@uidotdev/usehooks";
import { Link } from 'react-router-dom';

function WorksPageGridItem({
    id,
    slug,
    gridArea,
    thumbnail,
    name,
    description
}) {
    const globalStore = useGlobalStore();

    const [ref, hovering] = useHover();

    useEffect(() => {
        if (hovering) {
            globalStore.setCursorPopupText("Zoeiter ce projet");
            globalStore.setCursorPopupActive(true);
        } else {
            globalStore.setCursorPopupActive(false);
        }
    }, [hovering]);

    return (
        <div
            style={{
                gridArea: gridArea,
                backgroundImage: `url(${thumbnail})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            ref={ref}
        >
            <Link className="w-full h-full flex flex-col justify-end transition-all opacity-0 hover:opacity-100 duration-300 tablet:opacity-100" to={`/realisations/${slug}`}>
                <div className="p-8 bg-gradient-to-t from-black to-transparent">
                    <h3 className="font-bold text-heading-5">{name}</h3>
                    <p>{description}</p>
                </div>
            </Link>
        </div>
    )
}

export default function WorksPageGrid({ items = [] }) {
    const [gridTemplates, setGridTemplates] = useState([]);

    // Media query pour détecter les tailles d'écran
    const isTablet = useMediaQuery({ maxWidth: 1000 });
    const isMobile = useMediaQuery({ maxWidth: 780 });

    // Fonction pour découper le tableau "items" en sous-tableaux de 7 éléments
    const chunkItems = (arr, size) => {
        let result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    // Découpe "items" en sous-tableaux de 7
    const chunks = chunkItems(items, 7);

    // Templates pour chaque taille d'écran
    const getGridTemplate = (subArray, isEven) => {
        const gridAreas = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

        let filledAreas = subArray.map((_, i) => gridAreas[i]);
        const missing = 7 - subArray.length;

        // Combler les trous par prolongement des éléments existants
        if (missing > 0 && !isMobile) {
            for (let i = 0; i < missing; i++) {
                filledAreas.push(gridAreas[subArray.length - 1]);
            }
        }

        // Templates pour les différentes tailles d'écrans
        const normalTemplate = subArray.length > 3 ? `"${filledAreas[0]} ${filledAreas[0]} ${filledAreas[0]} ${filledAreas[1]} ${filledAreas[1]} ${filledAreas[2]}" 
                              "${filledAreas[0]} ${filledAreas[0]} ${filledAreas[0]} ${filledAreas[1]} ${filledAreas[1]} ${filledAreas[2]}" 
                              "${filledAreas[3]} ${filledAreas[4]} ${filledAreas[4]} ${filledAreas[4]} ${filledAreas[5]} ${filledAreas[5]}" 
                              "${filledAreas[3]} ${filledAreas[4]} ${filledAreas[4]} ${filledAreas[4]} ${filledAreas[6]} ${filledAreas[6]}"` :

                              `"${filledAreas[0]} ${filledAreas[0]} ${filledAreas[0]} ${filledAreas[1]} ${filledAreas[1]} ${filledAreas[2]}" 
                              "${filledAreas[0]} ${filledAreas[0]} ${filledAreas[0]} ${filledAreas[1]} ${filledAreas[1]} ${filledAreas[2]}"`

        const tabletTemplate = `"${filledAreas[0]} ${filledAreas[0]} ${filledAreas[1]}" 
                              "${filledAreas[2]} ${filledAreas[3]} ${filledAreas[3]}" 
                              "${filledAreas[4]} ${filledAreas[4]} ${filledAreas[5]}" 
                              "${filledAreas[6]} ${filledAreas[6]} ${filledAreas[6]}"`;

        const mobileTemplate = filledAreas.map(area => `"${area}"`).join('\n');

        return isMobile ? mobileTemplate : isTablet ? tabletTemplate : normalTemplate;
    };

    // Actualisation des templates en fonction de la taille de l'écran
    useEffect(() => {
        const updatedTemplates = [...chunks].map((chunk, index) =>
            getGridTemplate(chunk, index % 2 === 0)
        );
        setGridTemplates(updatedTemplates);
    }, [isMobile, isTablet, items]);

    return (
        <div className="max-w-[1661px] mx-auto space-y-[2.5rem] text-white mb-[6.5rem] px-6 mt-32">
            {chunks.map((chunk, index) => (
                <div
                    key={index}
                    className="grid gap-[2.5rem] auto-rows-[250px]"
                    style={{
                        gridTemplateAreas: gridTemplates[index],
                    }}
                >
                    {chunk.map((item, i) => (
                        <WorksPageGridItem {...item} key={i} gridArea={['a', 'b', 'c', 'd', 'e', 'f', 'g'][i]} />
                    ))}
                </div>
            ))}
        </div>
    );
}
